export default __webpack_public_path__ + "static/media/mongodb.f6656e23.svg";